import { useCallback } from 'react'
import { Sheet } from 'react-modal-sheet'
import BottomSheet from '~components/ui/bottom-sheet'
import EditPetInfo from '~containers/app/edit-pet-info'
import Loading from '~containers/general/loading'
import Pet from '~models/pet'

const UpdatePetBottomSheet = ({
  isOpen,
  onCloseRequest,
  onPetUpdateSuccess,
  pet,
}: Omit<Parameters<typeof BottomSheet>[0], 'children'> & {
  pet: Pet.ILevel1 | null
  onPetUpdateSuccess: (data: Pet.ILevel1, variables: Pet.ILevel1) => void
}) => {
  const _onPetUpdateSuccess = useCallback(
    (data: Pet.ILevel1, variables: Pet.ILevel1) => {
      onPetUpdateSuccess(data, variables)
      onCloseRequest()
    },
    [onCloseRequest, onPetUpdateSuccess]
  )
  return (
    <BottomSheet isOpen={isOpen} onCloseRequest={onCloseRequest}>
      {pet ? (
        <Sheet.Scroller>
          <main className="w-full p-5">
            <EditPetInfo pet={pet} onSuccess={_onPetUpdateSuccess} />
          </main>
        </Sheet.Scroller>
      ) : (
        <Loading />
      )}
    </BottomSheet>
  )
}

export default UpdatePetBottomSheet
